<template lang="html">
  <div class="wrapper" :style="{ 'background-image': 'url(' + data.background + ')', 'background-color': '#EEEEEE' } " v-if="data">
    
    <div class="bg-progressbar">
      <div v-if="!data.completed" class="container-fluid">
          <b-progress height="1.5rem">
            <b-progress-bar :value="valueProgressBar" :label="`${valueProgressBar}%`" variant="success"></b-progress-bar>
          </b-progress>
      </div>
    </div>
    <div class="bg text-center">
      <div class="container-fluid" style="height: 85%;">
        <img :src="data.logo" alt="Logo de la compañia" class="logo">
        <div class="row justify-content-center">
          <div class="col-12 col-md-11 text-center">
            <template v-if="!completed && !data.completed && data.round.active">
              <template v-for="(question, index) in currentQuestions">
                <b-row :key="question.id">
                  <simple-text
                    :key="question.id"
                    v-if="question.type === 'TEXT'"
                    :question="changeTitleTags(question, data.contact)"
                  ></simple-text>
                  <radio
                    :key="question.id"
                    v-else-if="question.type === 'RADIO'"
                    :question="changeTitleTags(question, data.contact)"
                  ></radio>
                  <check
                    :key="question.id"
                    v-else-if="question.type === 'CHECK'"
                    :question="changeTitleTags(question, data.contact)"
                  ></check>
                  <nps
                    :key="question.id"
                    v-else-if="question.type === 'NPS'"
                    :question="changeTitleTags(question, data.contact)"
                  ></nps>
                  <numeral
                    :key="question.id"
                    v-else-if="question.type === 'NUMERAL'"
                    :question="changeTitleTags(question, data.contact)"
                  ></numeral>
                  <smiley
                    :key="question.id"
                    v-else-if="question.type === 'SMILEY'"
                    :question="changeTitleTags(question, data.contact)"
                    :order ="'right'"
                  ></smiley>
                  <list
                    :key="question.id"
                    v-if="question.type === 'LIST'"
                    :question="changeTitleTags(question, data.contact)"
                  ></list>
                </b-row>
              </template>
              <b-row class="mt-5">
                <b-col class="center-buttom-footer" align-self="start">
                  <v-btn outline @click = "changeStep(-1)" v-if="active_step != 0" :style="{ color:data.client.color }"> 
                    <i class="material-icons">
                      arrow_back
                    </i>
                  </v-btn>
                </b-col>
                <b-col class="center-buttom-footer" align-self="end">
                  <v-btn outline @click = "sendData" :disabled="validate" :style="{ color:data.client.color }" >
                    <i class="material-icons">
                      arrow_forward
                    </i>
                  </v-btn>
                </b-col>
              </b-row>
            </template>
            <div class="text-center" v-if="completed">
              <h2 v-html="data.round.message_success ? data.round.message_success : 'Encuesta contestada satisfactoriamente.'"></h2>
              <h3 v-html="data.round.message_sub ? data.round.message_sub : '¡Muchas gracias por tu tiempo, estamos en confianza!'"></h3>
            </div>
            <div class="stext-center" v-else-if="data.completed">
              <h2 v-html="data.round.message_answered ? data.round.message_answered : 'La encuesta ya ha sido contestada.'"></h2>
              <h3 v-html="data.round.message_sub ? data.round.message_sub : '¡Muchas gracias por tu tiempo, estamos en confianza!'"></h3>
            </div>
            <div class="text-center" v-else-if="!data.round.active">
              <h2 v-html ="data.round.message_expired ? data.round.message_expired : 'La encuesta a expirado.'"></h2>
            </div>

          </div>
        </div>
        <div>
          <a :href="defaulWeb" target="_blank" :hidden="hiddenLogo">
              <img :src="defaultLogo" alt="Logo knower.io" class="branding">
          </a>
        </div>
      </div>
      
    </div>
    <div class="loader" v-if="loader">
      <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import './sass/survey.css';
import axios from 'axios';
import SimpleText from './components/SimpleText.vue';
import Radio from './components/Radio.vue';
import Check from './components/Check.vue';
import Nps from './components/Nps.vue';
import Numeral from './components/Numeral.vue';
import Smiley from './components/Smiley.vue';
import { mapGetters } from 'vuex';
import List from './components/List.vue';

Vue.use(BootstrapVue);

export default {
  components: {
    SimpleText,
    Radio,
    Check,
    Nps,
    Numeral,
    Smiley,
    List
  },
  data: () => {
    return {
      question: {},
      completed: false,
      steps: null,
      active_step: 0,
      loader: true,
      prev_id: '',
      data: null,
      contact_id: null,
      email: null,
      round_id: null,
      survey_id: null,
      score: null,
      defaultLogo: process.env.LOGO_PATH,
      defaultWeb: process.env.URL_WEB
    };
  },
  computed: {
    currentStep: function () {
      return this.steps[this.active_step];  
    },
    currentQuestions: function () {
      return this.currentStep.questions; 
    },
    validate: function () {
      for (let index = 0; index < this.currentStep.questions.length; index++) {
        if (this.currentStep.questions[index].value === null && this.currentStep.questions[index].type !== 'RADIO' && this.currentStep.questions[index].type !== 'CHECK') {
          if (this.currentStep.questions[index].type === 'TEXT') {
            return false;
          }
          return true;
        }
        if (this.currentStep.questions[index].type === 'RADIO' || this.currentStep.questions[index].type === 'CHECK') {
          if (this.currentStep.questions[index].options_values.length === 0) {
            console.log('trando');
            return true;
          }
          return false; 
        }
      }  
    },
    hiddenLogo: function () {
      if (this.data.client.hidden_logo_knower) {
        return true;
      }
      return false;
    },
    valueProgressBar: function () {

      return this.completed ? 100 : Math.round((this.active_step / this.steps.length) * 100);
    }
  },
  mounted () {
    this.loadData();
  },
  methods: {
    loadData () {
      this.contact_id = this.$route.params.contact_id;
      this.survey_id = this.$route.params.survey_id;
      this.round_id = this.$route.params.round_id;
      this.score = this.$route.params.score;
      this.email = this.$route.params.email;
      let url = 'survey/' + this.contact_id + '/' + this.round_id + '/' + this.email;
      if (this.score) {
        url += '/' + this.score;
      }
      axios.get(url).then(response => {
        this.data = response.data.data;
        this.steps = this.data.steps;
        /* set value to email click */ 
        this.checkIndex();
        
        this.loader = false;
        
      }).catch(error => {
        this.loader = false;
      });
    },
    changeStep (i) {
      const aux = this.active_step + i;

      if (aux === this.data.steps.length) {
        this.completed = true;
      } else {
        this.active_step = aux;
      }
    },
    sendData () {
      let url = 'survey/' + this.data.survey.id + '/contact/' + this.data.contact.id + '/round/' + this.data.round.id + '/email/' + this.email;
      if (this.data.contact.test) {
        url += '/test';
      }
      const payload = {
        survey_id: this.survey_id,
        questions: this.currentQuestions,
        round_id: this.round_id,
        contact_id: this.data.contact.id,
        email_id: this.email,
      };

      this.changeStep(1);
      
      axios.post(url, payload).then(response => {
      }).catch(error => {
      });
      
    },
    checkIndex () {
      if (!this.data.completed) {
        if (this.steps[0].questions[0].type === 'NPS' && this.score) {
          this.steps[0].questions[0].value = this.score;
          this.sendData();
        }
        if (this.steps[0].questions[0].type === 'RADIO' && this.score) {
          this.steps[0].questions[0].options_values[0] = this.score;
          this.sendData();
        }
        if (this.steps[0].questions[0].type === 'NUMERAL' && this.score) {
          this.steps[0].questions[0].value = this.score;
          this.sendData();
        }
      }
    
      for (let index = 0; index < this.steps.length; index++) {
        for (let key = 0; key < this.steps[index]['questions'].length; key++) {
          if (this.steps[index]['questions'][key]['value'] === null) {
            if (this.steps[index]['questions'][key]['type'] === 'CHECK' || this.steps[index]['questions'][key]['type'] === 'RADIO') {
              if (this.steps[index]['questions'][key]['options_values'].length === 0) {
                this.active_step = index;
                return index;
              }
            } else {
              this.active_step = index;
              return index;
            }
          }
      
        }
      }
    },
    changeTitleTags (question, contact) {
      let title = question.title;
      if (!contact.test) {     
        title = title.replace('##segmentation1##', contact.segmentation);
        title = title.replace('##segmentation##', contact.segmentation);
        title = title.replace('##segmentation2##', contact.segmentation2);
        title = title.replace('##tag##', contact.tag);
        title = title.replace('##company##', contact.company);
        title = title.replace('##seniority##', contact.seniority);
        title = title.replace('##name##', contact.name);
        title = title.replace('##country##', contact.country);      
        title = title.replace('##position##', contact.position);
        title = title.replace('##priority##', contact.priority);
      }
      question.title = title;
      
      return question;
    }

  }
};
</script>

<style>
.center-buttom-footer {
    top: 50% !important;
    transform: translateY(85%) !important;
}
.progress-bar-top{
  background-color: white;
  margin-top: -20px;
}

</style>



// WEBPACK FOOTER //
// src/surveys/SurveyMailing.vue